export function Button({
  type = "button",
  size = "md",
  color = "primary",
  outline = false,
  title = "",
  onClick = () => {},
  disabled = false,
}) {
  return (
    <button
      type={type}
      className={`btn btn-${size} btn${outline ? "-outline" : ""}-${color}`}
      onClick={onClick}
      disabled={disabled}
    >
      {title}
    </button>
  );
}
